var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
// removed import of scss-style
import ClearButton from '../clear-button/ClearButton';
import { TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
class SearchInput extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const _a = this.props, { className, value, onInputChange, onClear, placeholder } = _a, rest = __rest(_a, ["className", "value", "onInputChange", "onClear", "placeholder"]);
        return (React.createElement("div", Object.assign({}, rest),
            React.createElement(TextField, { onChange: onInputChange, value: value, className: classnames('SearchInput__Input'), placeholder: placeholder, variant: 'outlined', InputProps: {
                    startAdornment: (React.createElement(InputAdornment, { position: 'start' },
                        React.createElement(SearchIcon, { style: { color: '#007A9C' } })))
                } }),
            React.createElement(ClearButton, { className: 'SearchInput__Clear', onClick: onClear })));
    }
}
export default SearchInput;
